<template>
    <div class="project-members-type-ahead">
        <type-ahead
            icon="far fa-user-plus"
            placeholder="Name or Role"
            v-model="internalModel"
            multiple
            :options="dropdownOptions"
            :options-filter="() => true"
            @highlight="handleHighlight"
            @search="updateSearchValue"
            autofocus
        >
            <template
                v-slot:option="{option, index, handler}"
            >
                <li
                    :key="option.value"
                    class="dropdown-item d-flex justify-content-between cursor-pointer"
                    @click.stop="() => handler(option)"
                    :class="{
                                'highlight': highlight === index
                            }"
                >
                    <span>{{ option.user.fullName }}</span>
                    <span class="text-gray-800">{{ option.workspaceMembershipType.name }}</span>
</li>
            </template>
        </type-ahead>
    </div>
</template>

<script>
    import './ProjectMembersTypeAhead.scss';
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import {ApiFilter, AppResourceSearch} from "@milestoneslabs/milestones-js-engine";
    import TypeAhead from "@milestoneslabs/milestones-ui-kit/src/components/TypeAhead/TypeAhead";
    import get from 'lodash/get';
    import {store} from "../../../../index";
    import VModel from '@milestoneslabs/milestones-ui-kit/src/mixins/VModel';

    export const PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY = 'PropertySavedSearchesShareModal:display';

    export default {
        name: "ProjectMembersTypeAhead",

        components: {
            TypeAhead,
        },

        mixins: [
            ShowNotificationMixin,
            VModel,
        ],

        data() {
            return {
                highlight: null,
                options: [],
                searchValue: null,
                projectMembersAppResourceSearch: new AppResourceSearch('workspace-organization-member'),
            };
        },

        computed: {
            dropdownOptions() {
                return this.options.filter(this.optionsFilter);
            },
        },

        async beforeMount() {
            this.options = await this.fetchProjectMembers();
        },

        methods: {
            handleHighlight(value) {
                this.highlight = value;
            },

            updateSearchValue(search) {
                this.searchValue = search;
            },

            optionsFilter(option) {
                if (!this.searchValue) {
                    return true;
                }

                let userName = get(option, 'user.fullName');
                let roleName = get(option, 'workspaceMembershipType.name');

                if (!this.internalModel.some(item => item.uuid === option.uuid) &&
                    (
                        userName.toLowerCase().includes(this.searchValue.toLowerCase()) ||
                        roleName.toLowerCase().includes(this.searchValue.toLowerCase())
                    )) {
                    return true;
                }
                return false;
            },

            async fetchProjectMembers() {
                let searchData = {
                    pagination: 'disabled',
                    include: [
                        'user.avatarFile',
                        'workspaceMembershipType',
                    ],
                    filter: new ApiFilter({
                        orderBy: {
                            createdAt: 'asc',
                        },
                        params: {
                            uuid: {
                                operator: '!=',
                                value: store.getters.getWorkspaceOrganizationMemberUuid,
                            },
                            workspaceUuid: store.getters.getWorkspaceUuid,
                        },
                    })
                };

                this.projectMembersAppResourceSearch.setSearchData(searchData, false);

                try {
                    await this.projectMembersAppResourceSearch.search();
                    return this.projectMembersAppResourceSearch.appResourceCollection.toArray();

                } catch (e) {
                    console.error(e);
                    this.showNotification({
                        message: 'Project members could not be loaded. Please, try again later.',
                        type: 'error',
                    });
                }
                ;
            },
        }
    };
</script>
